import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";

@Options({
    template: false,
    ui: {}
})

export default class SiblingNavView extends Marionette.View<Backbone.Model>{
    config?: object;
    element?: any;
    selectElement?: any;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};
        this.element = this.$el.get(0);
        this.selectElement = this.element.querySelector('select');
    }

    onRender() {
        // set selected to current page even if we are navigating back in history
        let children = this.selectElement.children;
        for(let i = 0; i<children.length; i++) {
            if(children[i].getAttribute('selected') != null) {
                this.selectElement.selectedIndex = i;
                break;
            }
        }

        // if you're reading this, this isn't used! on the memberships page
        // instead, that logic is in membership-table-view.ts in a function
        // called currentSelectOption(). this still exists in case you
        // want to use sibling nav outside of the memberships page though

        // go to selected page when changed
        this.selectElement.addEventListener('change', event => {
            window.location = this.selectElement.options[this.selectElement.selectedIndex].value;
        });
    }
}




// WEBPACK FOOTER //
// ./@modules/views/sibling-nav-view.ts